import React from "react";
import styles from "./AftersalesInformation.module.css"
import {Section} from "../../../../../elements/section/Section";
import {FullLocationUi, NewVehicleDataConfigurationDTOVehicleTypeEnum} from "../../../../../../api/generated";
import {getVehicleTypeTitle} from "../../../../../../utils/enumValueTitleUtil";
import {LeftSideTextField} from "../../../../../elements/leftSideTextField/LeftSideTextField";
import {LocationAvailability} from "../LocationDetails/LocationAvailability/LocationAvailability";

interface LocationDetailsProps {
    location: FullLocationUi
}

export const AftersalesInformation: React.FC<LocationDetailsProps> = ({
                                                                          location
                                                                      }) => {

    const aftersalesEnabled = location.aftersalesEnabled;
    const supportedVehicles = Object.entries(location.supportedVehicleManufacturers || {})
        .map(([manufacturer, vehicleTypes]) => `${manufacturer}: ${vehicleTypes.length > 0
            ? vehicleTypes.map(vehicleType => getVehicleTypeTitle(vehicleType as NewVehicleDataConfigurationDTOVehicleTypeEnum)).join(", ")
            : "All types"}`);

    return <Section title={"Aftersales Information"}>
        <div className={styles.fieldsWrapper}>
            <LeftSideTextField
                title={"Aftersales Enabled"}
                value={location.aftersalesEnabled ? "Enabled" : "Disabled"}
            />
            {aftersalesEnabled && <LeftSideTextField title={"Transcript Recipient(s)"} value={location.aftersalesEmailTranscriptRecipients.join("; ")}/>}
            {aftersalesEnabled && <LeftSideTextField title={"Transcript Filtration"} value={location.aftersalesEmailFiltrationEnabled ? "Enabled" : "Disabled"}/>}
            {aftersalesEnabled && <LeftSideTextField title={"Transcript Summary"} value={location.aftersalesEmailTranscriptSummaryEnabled ? "Enabled" : "Disabled"}/>}
            {aftersalesEnabled && <LeftSideTextField title={"Supported Vehicles"} value={supportedVehicles.length > 0 ? supportedVehicles.join("; ") : "All vehicles"}/>}
            {aftersalesEnabled && <LeftSideTextField title={"Service Appointment URL"} value={location.serviceBookingUrl}/>}
            {aftersalesEnabled && location.recallUrl && <LeftSideTextField title={"Recall URL"} value={location.recallUrl}/>}
            {aftersalesEnabled && <LocationAvailability workSchedule={location.aftersalesWorkSchedule}/>}
        </div>
    </Section>
}
